<div class="wrapper">
    <p class="font-weight-bold" id="title">
        Werte
    </p>
    <div class="card">
        <div class="card-body">

            <app-table-header
                    [pageIndex]="0"
                    [pageCount]="1"
                    [error]="valuesService.error"
                    [loading]="valuesService.loading"
                    [disableFilter]="true"
                    (reload)="valuesService.loadValues()"
            >
            </app-table-header>

            <ng-container *ngIf="valuesService.data != null">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                <p>Name</p>
                            </th>
                            <th>
                                <p>Wert</p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><p>{{ValueExcelField.goldPreis}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.goldPreis] | euro}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.silberPreis}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.silberPreis] | euro}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.platinPreis}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.platinPreis] | euro}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.palladiumPreis}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.palladiumPreis] | euro}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.kalkulationsfaktorMinora}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.kalkulationsfaktor][Shop.minora] | decimal}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.kalkulationsfaktorTw}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.kalkulationsfaktor][Shop.tw] | decimal}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.kalkulationsfaktorCilorB2B}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.kalkulationsfaktor][Shop.cilorB2B] | decimal}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.kalkulationsfaktorCilorB2C}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.kalkulationsfaktor][Shop.cilorB2C] | decimal}}</p></td>
                    </tr>
                    <tr>
                        <td><p>{{ValueExcelField.kalkulationsfaktorSchmuckwunder}}</p></td>
                        <td><p>{{valuesService.data.values[ValueField.kalkulationsfaktor][Shop.schmuckwunder] | decimal}}</p></td>
                    </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </div>
</div>
